export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f37db145dfe05c232a58b6edc98b38349eac974ec&name=fetchTypeahead!'